import * as React from "react"
import { useState, useEffect } from "react"
import { Box, Tab, Tabs, Button, Grid } from "@mui/material"
import AddImage from "../components/AddImage"
import KeypointTab from "../../components/home/KeypointTab"
import EditImage from "../components/EditImage"

export default function FindClimb() {
  const [value, setValue] = useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Add Image" />
          <Tab label="Edit Image" />
          <Tab label="Keypoint" />
        </Tabs>
      </Box>
      <div style={{ display: value === 0 ? "block" : "none" }}>
        <AddImage />
      </div>
      <div style={{ display: value === 1 ? "block" : "none" }}>
        <EditImage />
      </div>
      <div style={{ display: value === 2 ? "block" : "none" }}>
        <KeypointTab />
      </div>
    </Box>
  )
}
